import clsx from "clsx";

/**
 * Generic shimmer placeholder. Use it as the building block for any loading
 * state instead of hand-rolling `animate-pulse` + `bg-gray-*` divs so every
 * skeleton in the app looks the same.
 */
export const Skeleton: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => (
  <div
    className={clsx("animate-pulse rounded-md bg-ink/[0.07]", className)}
    aria-hidden="true"
    {...props}
  />
);
